export interface Career {
  id: string;
  title: string;
  description: string;
  requirements?: string[];
}

export const careers: Career[] = [
  {
    id: "frontend-developer",
    title: "Frontend Developer",
    description:
      "We’re looking for an experienced frontend developer to join our team. In this role, you'll collaborate with designers, backend developers, and project managers to bring custom websites and web apps to life. You’ll work on a variety of projects, from marketing sites to full-scale applications, using modern tools and frameworks.",
    requirements: [
      "3+ years of professional experience in frontend development",
      "Proficiency in HTML, CSS (SASS/SCSS), and JavaScript (ES6+)",
      "Strong experience with Vue.js or React",
      "Deep understanding of modern WordPress development",
      "Comfortable working with Git version control",
      "Strong debugging and troubleshooting skills",
      "Excellent communication and collaboration",
    ],
  },
  {
    id: "freelance-frontend-developer",
    title: "Freelance Frontend Developer",
    description:
      "We’re looking for an experienced freelance frontend developer to join our team on a project basis, with the potential to transition into a full-time position. In this role, you'll collaborate with designers, backend developers, and project managers to bring custom websites and web apps to life. You’ll work on a variety of projects, from marketing sites to full-scale applications, using modern tools and frameworks.",
    requirements: [
      "3+ years of professional experience in frontend development",
      "Proficiency in HTML, CSS (SASS/SCSS), and JavaScript (ES6+)",
      "Strong experience with Vue.js or React",
      "Deep understanding of modern WordPress development",
      "Comfortable working with Git version control",
      "Strong debugging and troubleshooting skills",
      "Excellent communication and collaboration",
    ],
  },
  {
    id: "freelance-backend-developer",
    title: "Freelance Backend Developer",
    description:
      "We're seeking a freelance backend developer to support our team on a part-time basis (approximately 20 hours per week). This role focuses on backend web development using PHP and the Laravel framework, as well as DevOps and server administration. The ideal candidate is a reliable problem-solver who writes clean code, understands server environments, and can contribute to custom application development. For the right person, this opportunity could evolve into a full-time position.",
    requirements: [
      "3+ years of professional experience with PHP and Laravel",
      "Strong knowledge of MySQL and relational database design",
      "Proficient with Git and version control best practices",
      "Hands-on experience with Linux server administration (LAMP stack)",
      "Familiarity with CI/CD and basic deployment pipelines",
      "Excellent communication and time management skills",
      "Able to work independently and meet deadlines",
      "Attention to detail and commitment to writing clean, maintainable code",
    ],
  },
];
